module.exports = __webpack_public_path__ + "static/media/btn-splash.383f7d35.svg";